import { useEffect, useRef } from 'react';

export function useDebouncedCommit<T>(commit: (value: T) => void, delay = 100) {
  const latestCommit = useRef(commit);
  latestCommit.current = commit;
  const pending = useRef<{ timer: ReturnType<typeof setTimeout>; value: T } | null>(null);

  useEffect(
    () => () => {
      if (!pending.current) return;
      clearTimeout(pending.current.timer);
      latestCommit.current(pending.current.value);
      pending.current = null;
    },
    []
  );

  return (value: T) => {
    if (pending.current) clearTimeout(pending.current.timer);
    pending.current = {
      value,
      timer: setTimeout(() => {
        pending.current = null;
        latestCommit.current(value);
      }, delay),
    };
  };
}
